import env from 'env'

export const updatePaymentDetails = data => ({
  type: 'api/cards/UPDATE_CARD',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/cards/current',
      data,
      headers: {},
      method: 'PUT',
    },
  },
  meta: {
    noAuth: true,
  },
})
updatePaymentDetails.toString = () => 'api/cards/UPDATE_CARD'

export const updateBillingAddress = (billingAddress) => ({
  type: 'api/cards/UPDATE_BILLING_ADDRESS',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/cards/current/billing-address',
      data: {
        billingAddress,
      },
      headers: {},
      method: 'PUT',
    },
  },
  meta: {
    noAuth: true,
  },
})
updateBillingAddress.toString = () => 'api/cards/UPDATE_BILLING_ADDRESS'

export const verifyCurrentCard = () => ({
  type: 'api/cards/CARD_VEFIFY',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/cards/current/verify',
      data: {
      },
      headers: {},
      method: 'POST',
    },
  },
  meta: {
    noAuth: true,
  },
})
verifyCurrentCard.toString = () => 'api/cards/CARD_VEFIFY'
